import { Component, Inject, OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';

@Component({
  selector: 'app-delete-event-image',
  templateUrl: './delete-event-image.component.html',
  styleUrls: ['./delete-event-image.component.scss']
})
export class DeleteEventImageComponent implements OnInit {
  aviationEvent: AviationEvent;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<DeleteEventImageComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService) {
    this.aviationEvent = data.aviationEvent;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._aviationEventsService.deleteEventCoverImg(this.aviationEvent.eventId, this.aviationEvent.photos[0].photoId);
      this.isLoading = false;
      this.close({success: true});
    } catch (e) {
      this.close({success: false});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }

}
